/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />


abstract class BaseService{
    constructor(){
    }
}
export{BaseService};




// WEBPACK FOOTER //
// /home/circleci/project/org/Hibachi/client/src/core/services/baseservice.ts